import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  CustomModal,
  InputText,
  CustomDropdown,
  CustomCheckbox,
  Btn,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useStatusEtiquetaModal, { LOAD_MESSAGE } from './StatusEtiquetaModalHook'

const GRUPO_OPTIONS = [
  { label: 'Liberado', value: 'Liberado' },
  { label: 'Bloqueado', value: 'Bloqueado' },
]

function StatusEtiquetaModal({ show, data, onModalClose, onModalSave, selectedTp, dispatch }) {
  const { state, localDispatch } = useStatusEtiquetaModal()

  useEffect(() => {
    if (show) {
      localDispatch.start(data)
    }
  }, [show, data])

  useEffect(() => {
    if (!show) {
      localDispatch.reset()
    }
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Salvando Status', 'Aguarde...'))
        localDispatch
          .save(selectedTp)
          .then(saved => {
            dispatch(showMessageBox('Status salvo com sucesso.', null))
            onModalSave(saved)
            onModalClose()
          })
          .catch(err =>
            dispatch(showMessageBox(null, err && err.message ? err.message : String(err))),
          )
          .finally(() => dispatch(hideLoadingBox()))
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.clearError()
    }
  }, [state.errorMessage])

  const selectedGrupo = GRUPO_OPTIONS.find(o => o.value === state.item.grupo) || null
  const isEditing = !!(data && data.id)

  return (
    <CustomModal header="Status Etiqueta" isVisible={show} onClose={onModalClose} width={560}>
      <div className="p-grid">
        <div className="p-col-8">
          <InputText
            marginTop={10}
            label="Status:*"
            value={state.item.status || ''}
            onChange={v => localDispatch.onChange('status', v || '')}
          />
        </div>
        <div className="p-col-4">
          <CustomDropdown
            marginTop={10}
            label="Grupo:*"
            optionLabel="label"
            options={GRUPO_OPTIONS}
            value={selectedGrupo}
            onChange={opt => localDispatch.onChange('grupo', opt ? opt.value : null)}
            placeholder="Selecione"
            disabled={isEditing}
          />
        </div>
        <div className="p-col-12" style={{ display: 'flex', alignItems: 'center', marginTop: 6 }}>
          <CustomCheckbox
            checked={!!state.item.padrao}
            onChange={v => localDispatch.onChange('padrao', !!v)}
            disabled={state.item.grupo !== 'Liberado'}
          >
            Status Padrão
          </CustomCheckbox>
        </div>

        <div className="p-col-12" style={{ display: 'flex', alignItems: 'center', marginTop: 6 }}>
          <CustomCheckbox
            checked={!!state.item.active}
            onChange={v => localDispatch.onChange('active', !!v)}
          >
            Ativo
          </CustomCheckbox>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Btn onClick={() => localDispatch.onBtnSalvarClicked(selectedTp)}>Salvar</Btn>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(StatusEtiquetaModal)
